import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell } from "../../components/layout";
import DashboardsListPage from "./ui/DashboardsListPage";

const Dashboards = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <PageContentShell>
      <DashboardsListPage />
    </PageContentShell>
  </DashboardLayout>
);

export default Dashboards;
